import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row row-content mb-4 d-flex justify-content-between align-items-center" }
const _hoisted_2 = { class: "col-auto" }
const _hoisted_3 = { class: "col-auto" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "copy_all", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "row row-content mb-4" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = {
  key: 0,
  class: "row row-content mb-4 d-flex justify-content-between align-items-center"
}
const _hoisted_9 = { class: "col-auto" }
const _hoisted_10 = { class: "col-auto" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "copy_all", -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "row row-content mb-4"
}
const _hoisted_14 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_GenericFormWrapper = _resolveComponent("GenericFormWrapper")!

  return (_openBlock(), _createBlock(_component_GenericFormWrapper, {
    pageUI: _ctx.pageUI,
    submitData: _ctx.submitData,
    "align-buttons-right": true
  }, {
    content: _withCtx(({ errors }) => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('externalContent')) + " (nl)", 1),
            _createTextVNode(": " + _toDisplayString(_ctx.customNames.master_catalog_name.nl), 1)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "btn btn-hover btn-icon",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.customNames.custom_name.name.nl=_ctx.customNames.master_catalog_name.nl), ["prevent"]))
            }, _hoisted_5)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_InputText, {
              modelValue: _ctx.customNames.custom_name.name.nl,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => ((_ctx.customNames.custom_name.name.nl) = $event)),
                _ctx.onFormDataChanged
              ],
              name: "custom_product_name_nl",
              label: _ctx.$t('ownContent') + ' (nl)',
              rules: "max:255",
              "can-clear": "",
              errors: errors
            }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"])
          ])
        ]),
        (_ctx.AbilityContext.isAuthorizedForFeature('MULTILINGUAL'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.$t('externalContent')) + " (fr)", 1),
                _createTextVNode(": " + _toDisplayString(_ctx.customNames.master_catalog_name.fr), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  class: "btn btn-hover btn-icon",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.customNames.custom_name.name.fr=_ctx.customNames.master_catalog_name.fr), ["prevent"]))
                }, _hoisted_12)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.AbilityContext.isAuthorizedForFeature('MULTILINGUAL'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_InputText, {
                  modelValue: _ctx.customNames.custom_name.name.fr,
                  "onUpdate:modelValue": [
                    _cache[3] || (_cache[3] = ($event: any) => ((_ctx.customNames.custom_name.name.fr) = $event)),
                    _ctx.onFormDataChanged
                  ],
                  name: "custom_product_name_fr",
                  label: _ctx.$t('ownContent') + ' (fr)',
                  rules: "max:255",
                  "can-clear": "",
                  errors: errors
                }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["pageUI", "submitData"]))
}